import {$api, config} from "..";
import {GetPayLinkRequest, SberNotificationRequest} from "../../types/payment/payment.types";

export const addNotification = (data: SberNotificationRequest) => {
    return $api.post("/payment/notification", data, { headers: config()});
}

export const getPayLink = (data: GetPayLinkRequest) => {
    return $api.post("/payment/getPayLink", data, { headers: config()});
}